import { render } from "./CompanyAccount-AABBSms.vue?vue&type=template&id=4e2e5004&scoped=true"
import script from "./CompanyAccount-AABBSms.vue?vue&type=script&lang=js"
export * from "./CompanyAccount-AABBSms.vue?vue&type=script&lang=js"

import "./CompanyAccount-AABBSms.vue?vue&type=style&index=0&id=4e2e5004&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2e5004"]])

export default __exports__